import { useEffect } from "react";
import { useState } from "react";
import InputRange from "react-input-range";

const PirceSlider = ({priceData,setPriceData,priceData1,currency,setIsPriceChange}) => {
  const [price, setPrice] = useState({
    "min": 0,
    "max": 0
});

useEffect(()=>{
if(priceData1){
  const obj={
    min:priceData1?.min,
    max:priceData1?.max
  }
  setPrice(obj)
}
},[priceData1])

  const handleOnChange = (value) => {
    
    setPriceData(value)
    setIsPriceChange(true)
    // setPrice(value);
  };

  return (
    <div className="js-price-rangeSlider">
      <div className="text-14 fw-500"></div>

      <div className="d-flex justify-between mb-20">
        <div className="text-15 text-dark-1">
          <span className="js-lower mx-1">{currency ? currency : 'AED'} {priceData?.min}</span>-
          <span className="js-upper mx-1">{currency ? currency : 'AED'} {priceData?.max}</span>
        </div>
      </div>

      <div className="px-5">
        <InputRange
          formatLabel={(value) => ``}
          minValue={priceData1?.min}
          maxValue={priceData1?.max}
          value={priceData}
          onChange={(value) => handleOnChange(value)}
        />
      </div>
    </div>
  );
};

export default PirceSlider;
